export default __webpack_public_path__ + "static/englet-4-cea155f97fe696026363f88a676cf465.jpg";